import { PRODUCT_YOUXUAN } from '@constant'
import { isHotelProperty, isSiDaProperty } from '@merchant-backend/util'
import { isSiDaMember, isSiDaTeam } from '@util'

const THEME_TEMPLATE = {
  title: '主题模板',
  img: '//qnm.hunliji.com/o_1cvn2surk1udo1lfsj8g1qa3l4fh.png',
  link: '#/localMerchant/themeChose',
  openLink: '#/localMerchant/themeChose'
}

// 装修
export const DECORATION = forPro => {
  if (isHotelProperty()) {
    if (forPro) {
      return [
        {
          title: '皇冠标识',
          img: 'https://qnm.hunliji.com/Fq2XuAIeQlaCZEPTf8SZ3jHTedwW',
          link: `#/localMerchant/marketingCenter/detail/${PRODUCT_YOUXUAN}`,
          openLink: `#/localMerchant/marketingCenter/detail/${PRODUCT_YOUXUAN}`
        },
        {
          title: '定制礼品',
          img: 'https://qnm.hunliji.com/Ftcm1NzmIfnbSczwiiHnpDZcUVfe',
          link: '#/localMerchant/exclusiveOffers',
          openLink: '#/localMerchant/exclusiveOffers'
        },
        {
          title: '主题模板',
          img: 'https://qnm.hunliji.com/FvX2fF--Iueroy50QL0SLbW6YRHp',
          link: '#/localMerchant/themeChose',
          openLink: '#/localMerchant/themeChose'
        }
      ]
    } else {
      return [
        THEME_TEMPLATE,
        {
          title: '特色信息',
          img: '//qnm.hunliji.com/o_1dlght74e1u6g169f14c125356qn.png',
          link: '#/localMerchant/uniqueInfo',
          openLink: '#/localMerchant/uniqueInfo'
        },
        {
          title: '专享优惠',
          img: '//qnm.hunliji.com/o_1dlght74e77c1ltl1evrg961fc2r.png',
          link: '#/localMerchant/exclusiveOffers',
          openLink: '#/localMerchant/exclusiveOffers'
        },
        {
          title: '皇冠标识',
          img: '//qnm.hunliji.com/o_1dpfcb3vgii6168v1ltm52m1b47o.png',
          link: `#/localMerchant/marketingCenter/detail/${PRODUCT_YOUXUAN}`,
          openLink: `#/localMerchant/marketingCenter/detail/${PRODUCT_YOUXUAN}`
        }
      ]
    }
  }

  if (isSiDaProperty()) {
    if (isSiDaTeam()) {
      return []
    }

    return [THEME_TEMPLATE]
  }

  return [
    THEME_TEMPLATE,
    {
      title: '推荐橱窗',
      img: 'https://qnm.hunliji.com/o_1cvn2surkg306ma1euk1odp1egsg.png',
      link: '#/localMerchant/marketingCenter/detail/75',
      openLink: '#/localMerchant/decoration?type=recommendWindow',
      key: 'no_pro_decoration_dedail_75'
    },
    {
      title: '套餐热标',
      img: 'https://qnm.hunliji.com/o_1cvn2surk1u8b1uia2mi1p0112rmf.png',
      link: '#/localMerchant/marketingCenter/detail/70',
      openLink: '#/localMerchant/decoration?type=meal',
      key: 'no_pro_decoration_dedail_70'
    },
    {
      title: '商家承诺',
      img: 'https://qnm.hunliji.com/o_1cvn2surkhs6eq256n1ihbla9e.png',
      link: '#/localMerchant/marketingCenter/detail/72',
      openLink: '#/localMerchant/decoration?type=merchantPromise',
      key: 'no_pro_decoration_dedail_72'
    },
    {
      title: '咨询礼',
      img: 'https://qnm.hunliji.com/o_1cvn2surkrld9ubddk1m5n1t1ei.png',
      link: '#/localMerchant/marketingCenter/detail/32',
      openLink: '#/localMerchant/decoration?type=consultGift',
      key: 'no_pro_decoration_dedail_32'
    },
    {
      title: '到店礼',
      img: 'https://qnm.hunliji.com/o_1cvn2surk59q6kf1cavvcn1auj.png',
      link: '#/localMerchant/marketingCenter/detail/73',
      openLink: '#/localMerchant/decoration?type=gift',
      key: 'no_pro_decoration_dedail_73'
    }
  ]
}

// 营销
export const MARKETING = forPro => {
  if (forPro && isHotelProperty()) {
    return [
      {
        title: '优惠券',
        desc: '优惠券',
        img: 'https://qnm.hunliji.com/FqQtqKZ0CL5qNrtGxaaiNRTJOt3E',
        link: '#/localMerchant/coupons/detail?type=2',
        openLink: '#/localMerchant/coupons/detail?type=2',
        key: 'coupons_detail_type'
      },
      {
        title: '轻松聊',
        desc: '主动出击转化意向客户',
        img: 'https://qnm.hunliji.com/o_1d42elea6a441ur05e9u6no6j.png',
        link: '#/localMerchant/easyChat',
        openLink: '#/localMerchant/easyChat',
        key: 'no_pro_marketing_dedail_80'
      },
      {
        title: '智能接待',
        desc: '助你获取平台精准客资',
        img: 'https://qnm.hunliji.com/o_1d42eod3f1r2ioob1dm8v431knd12.png',
        link: '#/localMerchant/marketingCenter/detail/907',
        openLink:
          '/p/wedding/Public/admin/merchant_message/dist/index.html#/chat/settings/reception',
        key: 'no_pro_marketing_dedail_907',
        target: '_blank'
      }
    ]
  } else {
    return [
      !isSiDaMember()
        ? {
            title: '轻松聊',
            desc: '主动出击转化意向客户',
            img: 'https://qnm.hunliji.com/o_1d42elea6a441ur05e9u6no6j.png',
            link: '#/localMerchant/easyChat',
            openLink: '#/localMerchant/easyChat',
            key: 'no_pro_marketing_dedail_80'
          }
        : null,
      !isSiDaTeam()
        ? {
            title: '天眼系统',
            desc: '大数据助你获取潜在客资',
            img: 'https://qnm.hunliji.com/o_1d42eluoqrtmqii167ea14uvbo.png',
            link: '#/localMerchant/marketingCenter/detail/81',
            openLink:
              '/p/wedding/Public/admin/merchant_message/dist/index.html#/chat/privateLetter/talk',
            key: 'no_pro_marketing_dedail_81',
            target: '_blank'
          }
        : null,
      {
        title: '潜在客资转化',
        desc: '潜在客资批量联系转化',
        img: 'https://qnm.hunliji.com/o_1d42enoidt3enuo14e410q61a3mt.png',
        link: '#/localMerchant/skyEyeSystem/potentialCustomersIntro',
        openLink: '#/localMerchant/skyEyeSystem?tab=2',
        key: 'no_pro_marketing_potential_customers'
      },
      {
        title: '智能接待',
        desc: '助你获取平台精准客资',
        img: 'https://qnm.hunliji.com/o_1d42eod3f1r2ioob1dm8v431knd12.png',
        link: '#/localMerchant/marketingCenter/detail/907',
        openLink:
          '/p/wedding/Public/admin/merchant_message/dist/index.html#/chat/settings/reception',
        key: 'no_pro_marketing_dedail_907',
        target: '_blank'
      },
      !isSiDaProperty()
        ? {
            title: '优惠券',
            desc: '提升订单转化利器',
            img: 'https://qnm.hunliji.com/o_1d42epijak4ms4t1jhe2md1hli17.png',
            link: '#/localMerchant/marketingCenter/detail/82',
            openLink: '#/localMerchant/coupons',
            key: 'no_pro_marketing_dedail_82'
          }
        : null
    ].filter(Boolean)
  }
}

export const CHANNEL = forPro => {
  const REGISTRATION_ACTIVITY = {
    title: '微传单+',
    img: 'https://qnm.hunliji.com/o_1d42h0hpgkeul7nua4gs911u1m.png',
    link: '#/localMerchant/marketingCenter/detail/90',
    openLink: '#/localMerchant/registrationActivity',
    key: 'no_pro_chanel_detail_90'
  }

  const WEI_SHOP = {
    title: '微官网',
    img: 'https://qnm.hunliji.com/o_1d42h27ub1ahu1vib10vt15it1lms20.png',
    link: '#/localMerchant/weiShopSetting',
    openLink: '#/localMerchant/weiShopSetting',
    key: 'no_pro_chanel_detail_77'
  }

  if (isHotelProperty()) {
    if (forPro) {
      return [
        {
          title: '微官网',
          img: 'https://qnm.hunliji.com/FgWXJAMS9EOcrYvqaVptyicBTtOJ',
          link: '#/localMerchant/weiShopSetting',
          openLink: '#/localMerchant/weiShopSetting',
          key: 'no_pro_chanel_detail_77'
        },
        {
          title: '微传单+',
          img: 'https://qnm.hunliji.com/FlRxkZVtiKE1gsaattyXK9s9Ckki',
          link: '#/localMerchant/marketingCenter/detail/90',
          openLink: '#/localMerchant/registrationActivity',
          key: 'no_pro_chanel_detail_90'
        }
      ]
    } else {
      return [REGISTRATION_ACTIVITY, WEI_SHOP]
    }
  }

  return [
    REGISTRATION_ACTIVITY,
    {
      title: '商家电子请帖',
      img: 'https://qnm.hunliji.com/o_1d42im5576391bpe1fkker71g4r25.png',
      link: '#/localMerchant/marketingCenter/detail/909',
      openLink: '#/localMerchant/marketingCenter/detail/909',
      key: 'no_pro_chanel_detail_909'
    },
    {
      title: '小程序',
      img: 'https://qnm.hunliji.com/o_1d42h1po59a3iap1n2dgjpocj1r.png',
      link: '#/localMerchant/liteApp',
      openLink: '#/localMerchant/liteApp',
      key: 'no_pro_chanel_detail_liteApp'
    },
    WEI_SHOP
  ]
}
